<!-- 注册 -->
<template>
  <div class="content">
    <div class="register">
      <p class="title">新用户注册</p>
      <div class="line"></div>
      <div class="item">
        <span class="note">用户名</span>
        <input type="text" class="note_input" v-model="username"/>
        <span class="describle">必填</span>
      </div>

      <div class="item">
        <span class="note">密码</span>
        <input type="password" class="note_input" v-model="password"/>
        <span class="describle">由6-16位英文字母及数字组成</span>
      </div>

      <div class="item">
        <span class="note">确认密码</span>
        <input type="password" class="note_input" v-model="repassword"/>
        <span class="describle">必填</span>
      </div>

      <div class="item">
        <span class="note">真实姓名</span>
        <input type="text" class="note_input" v-model="truename"/>
        <span class="describle">必填</span>
      </div>

      <div class="item">
        <span class="note">身份证号</span>
        <input type="text" class="note_input" v-model="idcard"/>
        <span class="describle">必填</span>
      </div>

      <div class="item">
        <span class="note">联系电话</span>
        <input type="text" class="note_input" v-model="phone"/>
        <span class="describle">必填</span>
      </div>

      <div class="check">
        <input type="checkbox" v-model="checkstatus"/>
        <span>我已阅读并同意</span>
        <a @click="protocol">《通行证注册协议》</a>
      </div>

      <img class="register_btn" src="https://cdn.welove520.com/static/res/vue/playbay/register.png" @click="register">
    </div>
    <div class="bottom">
      <span>是否已有账号？如已注册，请直接登录 </span>
      <img src="https://cdn.welove520.com/static/res/vue/playbay/login_small.png" @click="login">
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      username: "",
      password: "",
      repassword: "",
      truename: "",
      idcard: "",
      phone: "",
      checkstatus: false
    };
  },
  created() {
    this.$store.dispatch("initTabName", "register");
  },
  methods: {
    /**
     * 注册
     */
    register: function() {
      if (!this.username) {
        alert("请填写用户名！");
        return false;
      }
      if (!this.password) {
        alert("请填写密码！");
        return false;
      }
      if (!this.repassword) {
        alert("请确认密码！");
        return false;
      }
      if (this.repassword != this.password) {
        alert("密码输入不一致！");
        return false;
      }
      if (!this.idcard) {
        alert("请填写身份证号！");
        return false;
      }

      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(this.idcard) == false) {
        alert("身份证输入不合法");
        return false;
      }

      let regNum = /^(\d)\1+$/;
      if (regNum.test(this.idcard) == true) {
        alert("身份证不能为相同数字");
        return false;
      }

      if (!this.truename) {
        alert("请填写真实姓名！");
        return false;
      }

      let reg2 = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
      if (!reg2.test(this.truename)) {
        alert("请填写正确姓名！");
        return false;
      }

      if (!this.phone) {
        alert("请填写联系电话！");
        return false;
      }

      if (this.phone.length < 6) {
        alert("请填写联系电话位数不够！");
        return false;
      }
      let regNum2 = /^(\d)\1+$/;
      if (regNum2.test(this.phone) == true) {
        alert("联系电话不能为相同数字");
        return false;
      }

      if (!this.checkstatus) {
        alert("请勾选阅读并同意！");
        return false;
      }

      alert("恭喜你注册成功！");
      return true;
    },

    /**
     * 协议
     */
    protocol: function() {
      this.$router.push({
        name: "Protocol"
      });
    },

    /**
     * 登录
     */
    login: function() {
      this.$router.push({
        name: "Login"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-end;
  width: 665px;
  margin: 40px auto 50px auto;
}

input{
  outline: none;
}

.register {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  width: 100%;
  height: 500px;
  border: 1px solid #f0b8c1;
  box-shadow: 0 0 6px 0 rgba(199, 117, 130, 0.31);
  border-radius: 10px;
}

.title {
  font-size: 16px;
  color: #e1556d;
  padding: 10px 0 10px 30px;
}

.line {
  border-style: dashed;
  border-bottom: 1px;
  width: calc(100% - 20px);
  color: #f193a3;
  margin: 0 10px;
}

.item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-top: 20px;
}

.note {
  width: 100px;
  text-align: right;
  font-size: 14px;
  color: #88898e;
}

.note_input {
  border-radius: 30px;
  border: 1px solid #b7b8be;
  width: 230px;
  height: 30px;
  margin-left: 10px;
  margin-right: 10px;
  padding-left: 10px;
}

.describle {
  font-size: 12px;
  color: #b7b8be;
}

.check {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-left: 110px;
  margin-top: 30px;
}

.check > input {
  width: 12px;
}

.check > span {
  font-size: 12px;
  color: #88898e;
  margin: 0 10px;
}

.check > a {
  font-size: 11px;
  color: #88898e;
  text-decoration: underline;
}

.register_btn {
  width: 140px;
  margin-top: 30px;
  margin-left: 150px;
}

.bottom {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.bottom > span {
  font-size: 12px;
  color: #88898e;
  text-align: center;
}

.bottom > img {
  width: 60px;
  margin: 10px 20px 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue